import React from "react";
import { Tag, Tooltip } from "antd";

/**
 * Ô "Thưởng" ở bảng Đơn hàng admin — trạng thái đơn trong Chương trình thưởng
 * (đợt mới, sổ RewardOrders) kèm LÝ DO nếu đơn không được thưởng.
 *
 * Có để admin trả lời ngay câu hỏi hay gặp nhất ("sao đơn này không được X2")
 * mà không phải mở modal đối soát của từng đợt rồi tìm mã đơn.
 * Cột X2 bên cạnh là hệ số đợt CŨ (appMultiplierApplied) — 2 cơ chế khác nhau.
 *
 * Chữ lý do do BE trả (services/reward-program/reward-reason-labels) nên admin
 * đọc đúng câu user đang thấy trong app; mã gốc nằm ở tooltip để đối soát.
 */
const STATUS_TAG = {
    awarded: { color: "green", text: "Đã cộng ví" },
    reserved: { color: "blue", text: "Giữ suất" },
    out_of_budget: { color: "orange", text: "Trượt" },
    cancelled: { color: "default", text: "Đơn huỷ" },
};

const fmtMoney = (n) => Number(n || 0).toLocaleString("vi-VN") + "đ";

function OrderRewardCell({ reward }) {
    if (!reward) return <span className="text-content-3">—</span>;

    const tag = STATUS_TAG[reward.status] || { color: "default", text: reward.status };
    const reasonText = reward.reasonText || reward.reason;
    const tip = [
        reward.programName,
        reward.amount > 0 ? `Thưởng ${fmtMoney(reward.amount)}` : null,
        reward.reason ? `${reasonText} (${reward.reason})` : null,
        reward.reasonHint,
    ].filter(Boolean).join(" · ");

    return (
        <Tooltip title={tip}>
            <div className="flex flex-col items-start gap-0.5">
                <Tag color={tag.color} className="m-0">{tag.text}</Tag>
                {reward.amount > 0 && <span className="text-xs text-green-600">{fmtMoney(reward.amount)}</span>}
                {reasonText && <span className="text-[11px] leading-tight text-content-3">{reasonText}</span>}
            </div>
        </Tooltip>
    );
}

export default OrderRewardCell;
